const Toolbar = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "5px",
        margin: "0 0 10px 0",
      }}
    >
      {children}
    </div>
  );
};
export default Toolbar;
